<template>
  <div id="detail-wrap2">
    <a class="close_btn" @click.prevent="back">
      <span>
        <i class="el-icon-close"></i>
      </span>
    </a>

    <div class="scroll_area" id="js_modal" v-if="Object.keys(formUploadFieldes).length">
      <div class="head_data">
        {{ contract.id }} - {{ contract.surname }} {{ contract.name }}（{{ contract.surname_kana }}
        {{ contract.name_kana }}）
        <span class="badge">{{ contract.contract_status_name }}</span>
      </div>
      <div v-show="formUploadFieldes.isBeri.isShow">
        <SegmentName>本人確認電話</SegmentName>
        <div class="table_block">
          <table>
            <tbody>
              <TableTr v-show="formUploadFieldes.beriTiming.isShow">
                <TableTh>
                  {{ formUploadFieldes.beriTiming.name }}
                  <RequiredText v-show="formUploadFieldes.beriTiming.required" />
                </TableTh>
                <td>
                  <InputRadio
                    :name="formUploadFieldes.beriTiming.key"
                    :choices="beriTimingOptionList"
                    :inputRadioVal.sync="form.beri_timing"
                    :handleChange="($event) => onChangeBeriTiming($event)"
                    :disabled="form.beri_timing === '完了済'"
                  />
                  <!-- <ErrorMessage class="error-beri_timing-required"></ErrorMessage> -->
                </td>
              </TableTr>
              <TableTr v-show="formUploadFieldes.beriAt.isShow">
                <TableTh>
                  {{ formUploadFieldes.beriAt.name }}
                  <RequiredText v-show="formUploadFieldes.beriAt.required" />
                </TableTh>
                <td>
                  <div>
                    <el-date-picker
                      class="u-w--200"
                      v-model="form.beri_at"
                      type="date"
                      :placeholder="formUploadFieldes.beriAt.placeholder"
                      format="yyyy/M/d"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :id="formUploadFieldes.beriAt.key"
                      :name="formUploadFieldes.beriAt.key"
                      :disabled="!formUploadFieldes.beriAt.required"
                      @change="onChangeBeriDate"
                    >
                    </el-date-picker>
                    <el-select
                      class="u-w--200"
                      v-model="beriTime"
                      :placeholder="formUploadFieldes.beriAt.placeholder"
                      :disabled="!formUploadFieldes.beriAt.required"
                      @change="onChangeBeriTime"
                    >
                      <el-option
                        v-for="item in beriTimeOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <ErrorMessage class="error-beri_at-required_if"></ErrorMessage>
                  <ErrorMessage class="error-beri_at-date"></ErrorMessage>
                </td>
              </TableTr>
            </tbody>
          </table>
        </div>
      </div>
      <SegmentName>口座振替確認</SegmentName>
      <div class="table_block" id="bank_account">
        <table>
          <tbody>
            <TableTr v-show="formUploadFieldes.bankAccountHolder.isShow">
              <TableTh>
                {{ formUploadFieldes.bankAccountHolder.name }}
                <RequiredText v-show="formUploadFieldes.bankAccountHolder.required" />
              </TableTh>
              <td>
                <InputRadio
                  :name="formUploadFieldes.bankAccountHolder.key"
                  :choices="formUploadFieldes.bankAccountHolder.choices"
                  :inputRadioVal.sync="form.bank_account_holder"
                />
                <ErrorMessage class="error-bank_account_holder-required"></ErrorMessage>
              </td>
            </TableTr>
            <TableTr v-show="formUploadFieldes.bankAccountHolderName.isShow">
              <TableTh>
                {{ formUploadFieldes.bankAccountHolderName.name }}
                <RequiredText v-show="formUploadFieldes.bankAccountHolderName.required" />
              </TableTh>
              <td>
                <el-input
                  class="u-w--200"
                  placeholder=""
                  :name="formUploadFieldes.bankAccountHolderName.key"
                  v-model="form.bank_account_holder_name"
                />
                <ErrorMessage class="error-bank_account_holder_name-required"></ErrorMessage>
                <ErrorMessage class="error-bank_account_holder_name-string"></ErrorMessage>
                <ErrorMessage class="error-bank_account_holder_name-kana_with_space"></ErrorMessage>
              </td>
            </TableTr>
            <TableTr v-show="formUploadFieldes.bankAccountRegistration.isShow">
              <TableTh>
                {{ formUploadFieldes.bankAccountRegistration.name }}
                <RequiredText v-show="formUploadFieldes.bankAccountRegistration.required" />
              </TableTh>
            <td>
              <ul class="bank-account__reg_list">
                <li>
                  <div><el-radio label="A" key="" v-model="bank_account_registration_a" @change="onChangeBankAccountRegistrationA">端末キャッシュカード登録(Anywhere Next)</el-radio></div>
                  <ul v-if="bank_account_registration_a === 'A' || form.bank_account_registration === 'A済' || form.bank_account_registration === 'A予定'">
                    <li><el-radio label="A予定" key="" name="bank_account_registration" v-model="form.bank_account_registration" @change="onChangeBankAccountRegistration">登録予定(A予定)</el-radio></li>
                    <li>
                      <el-radio label="A済" key="" name="bank_account_registration" v-model="form.bank_account_registration" @change="onChangeBankAccountRegistration">登録済(A済)</el-radio>
                        <div>
                          <el-date-picker
                            v-if="formUploadFieldes.bankAccountRegistrationDate.isShow"
                            class="u-w--200"
                            v-model="form.bank_account_registration_date"
                            type="date"
                            :placeholder="formUploadFieldes.bankAccountRegistrationDate.placeholder"
                            format="yyyy/M/d"
                            value-format="yyyy-MM-dd"
                            :id="formUploadFieldes.bankAccountRegistrationDate.key"
                            :disabled="!formUploadFieldes.bankAccountRegistrationDate.required"
                          >
                          </el-date-picker>
                          <p class="notice" v-if="formUploadFieldes.bankAccountRegistrationDate.isShow">
                            {{ note.bank_account_registration_date }}
                          </p>
                          <ErrorMessage class="error-bank_account_registration_date-required_if"></ErrorMessage>
                          <ErrorMessage class="error-bank_account_registration_date-date"></ErrorMessage>
                        </div>
                    </li>
                  </ul>
                </li>
                <li v-if="contract.store.options.find(x => x.has_payment === contract.has_payment).use_aplus === true">
                  <div><el-radio label="Web登録予定" key="" name="bank_account_registration" v-model="form.bank_account_registration" @change="onChangeBankAccountRegistration">Web登録予定</el-radio></div>
                  <p class="notice">※申込送信後に、お客様マイページよりご登録ください。</p>
                  <p class="notice">マイページはSMSで届くURLよりログインいただくか、当社ホームページ掲載のQRコードを読み取ることでもログイン可能です。</p>
                  <p class="notice">※SMS認証で、認証コードが届かなかったお客様はご利用できません。</p>
                </li>
                <li>
                  <div><el-radio label="口座振替依頼書" key="" name="bank_account_registration" v-model="form.bank_account_registration" @change="onChangeBankAccountRegistration">口座振替依頼書（郵送）</el-radio></div>
                  <p class="notice">※口座振替依頼書はTopページ「各種書類」より印刷いただきご利用ください。（白黒可）</p>
                </li>
              </ul>
              <ErrorMessage class="error-bank_account_registration-required"></ErrorMessage>
            </td>
            </TableTr>
          </tbody>
        </table>
      </div>
      <div class="segment">本人確認書類アップロード</div>
      <div class="table_block" id="identifications">
        <div class="clearfix camera">
          <div v-for="(item, index) in identifications" :key="index" class="camera__item float-left">
            <div class="camera__item--inner modal__img" @click="() => {
              item.see = true 
              activeUploadedImagesDialog(item, 'identifications')
            }" :class="{delete: item.delete}">
              <img :src="item.url" alt />
              <i class="el-icon-zoom-in"></i>
            </div>

            <!-- <el-dialog title="Upload Image" :visible.sync="item.see" width="80%" :modalAppendToBody="false">
              <div class="uploadImageWrapper">
                <img :src="item.url" alt width="100%" />
                <div class="text-center" style="margin-top: 15px" v-if="item.can_delete">
                  <el-button
                    type="danger"
                    @click="
                      item.see = false
                      imageDelete('identifications', item.id)
                    "
                  >
                    <i class="el-icon-delete"></i> 画像を削除する
                  </el-button>
                </div>
              </div>
            </el-dialog> -->
          </div>

          <div class="camera__item camera__item--add float-left" @click="activeCamera('identifications')">
            <div class="camera__item--inner">
              <i class="el-icon-camera camera__icon"></i>
              <p class="camera__txt">写真を追加する</p>
            </div>
          </div>
        </div>
        <p class="text-danger text-center" v-if="identifications_error">
          画像がアップロード出来ませんでした。再度アップお願いします。
        </p>
      </div>

      <div class="segment">エステ契約書、美容医療契約書、売買契約書、口座振替依頼書等のアップロード</div>
      <div class="table_block" id="contract_documents">
        <div class="clearfix camera">
          <div v-for="(item, index) in contract_documents" :key="index" class="camera__item float-left">
            <div class="camera__item--inner modal__img" @click="() => {
              item.see = true 
              activeUploadedImagesDialog(item, 'contract_documents')
            }" :class="{delete: item.delete}">
              <img :src="item.url" alt />
              <i class="el-icon-zoom-in"></i>
            </div>

            <!-- <el-dialog title="Upload Image" :visible.sync="item.see" width="80%" :modalAppendToBody="false">
              <div class="uploadImageWrapper">
                <img :src="item.url" alt width="100%" />
                <div class="text-center" style="margin-top: 15px" v-if="item.can_delete">
                  <el-button
                    type="danger"
                    @click="
                      item.see = false
                      imageDelete('contract_documents', item.id)
                    "
                  >
                    <i class="el-icon-delete"></i> 画像を削除する
                  </el-button>
                </div>
              </div>
            </el-dialog> -->
          </div>
          <div class="camera__item camera__item--add float-left" @click="activeCamera('contract_documents')">
            <div class="camera__item--inner">
              <i class="el-icon-camera camera__icon"></i>
              <p class="camera__txt">写真を追加する</p>
            </div>
          </div>
        </div>
        <p class="text-danger text-center" v-if="contract_documents_error">
          画像がアップロード出来ませんでした。再度アップお願いします。
        </p>
      </div>

      <div class="segment">親権者同意書のアップロード</div>
      <div class="table_block" id="parental_consent">
        <div class="clearfix camera">
          <div v-for="(item, index) in parental_consent" :key="index" class="camera__item float-left">
            <div class="camera__item--inner modal__img" @click="() => {
              item.see = true 
              activeUploadedImagesDialog(item, 'parental_consent')
            }" :class="{delete: item.delete}">
              <img :src="item.url" alt />
              <i class="el-icon-zoom-in"></i>
            </div>
          </div>
          <div class="camera__item camera__item--add float-left" @click="activeCamera('parental_consent')">
            <div class="camera__item--inner">
              <i class="el-icon-camera camera__icon"></i>
              <p class="camera__txt">写真を追加する</p>
            </div>
          </div>
        </div>
        <p class="text-danger text-center" v-if="parental_consent_error">
          画像がアップロード出来ませんでした。再度アップお願いします。
        </p>
      </div>

      <div class="text-center">
        <el-button
          type="primary"
          class="center"
          icon="el-icon-arrow-right"
          @click="sendPhoto"
          v-bind:disabled="isSendPhotoBtnPushed"
          >変更を保存する</el-button
        >
      </div>
      <el-dialog title="Upload Image" :visible.sync="uploadedImagesDialog.image.see" width="80%" :modalAppendToBody="false" :append-to-body="true">
        <div class="uploadImageWrapper">
          <div class="mb-2" v-if="!uploadedImagesDialog.image.can_delete">
            <!-- <el-button type="primary" @click="changeEditMode">
              画像を編集する
            </el-button> -->
            <el-button @click="rotateImage(uploadedImagesDialog.image.id)">
              <i class="el-icon-refresh-right"></i>画像を回転する
            </el-button>
          </div>
          <img :src="uploadedImagesDialog.image.url" alt width="100%" ref="targetImage" />
          <div class="text-center" style="margin-top: 15px" v-if="uploadedImagesDialog.image.can_delete">
            <el-button
              type="danger"
              @click="
                uploadedImagesDialog.image.see = false
                imageDelete(uploadedImagesDialog.type, uploadedImagesDialog.image.id)
              "
            >
              <i class="el-icon-delete"></i> 画像を削除する
            </el-button>
          </div>
        </div>
      </el-dialog>
      <!-- <el-dialog
        :title="'編集中'"
        :visible.sync="uploadedImagesDialog.isCanvas"
        width="80%"
        :append-to-body="true"
      >
        <div class="mb-2">
          <el-button type="primary" @click="changeEditMode">
            戻る
          </el-button>
        </div>
        <MaskImage 
          :imageUrl="uploadedImagesDialog.maskImageUrl" 
          :paramImageWidth="uploadedImagesDialog.imageWidth" 
          :paramImageHeight="uploadedImagesDialog.imageHeight" 
          :isClearRect="!uploadedImagesDialog.isCanvas" 
          :key="uploadedImagesDialog.maskImageUrl"
          @emitUpdateImage="updateImage"
        />
      </el-dialog> -->
    </div>
    <input
      type="file"
      name="upfile"
      id="upfile"
      accept="image/*"
      capture="camera"
      style="display: none"
      @change="uploadImage"
    />
  </div>
</template>

<script>
import moment from 'moment'
import {helperSmoothScroll} from '@/js/util/helper'
import {uploadFile} from '@/js/util/uploadFile'
import {FormUploadFieldes} from '@/js/util/member/formUploadFieldes'
import {validate} from '@/js/util/validate/validateFunction'
import {ValidationRules} from '@/js/util/member/formUploadValidationRules'
import {Note} from '@/js/util/member/formUploadOptionConstants'
import RequiredText from '@/js/components/member/common/Atoms/RequiredText'
import SegmentName from '@/js/components/member/common/Atoms/SegmentName'
import ErrorMessage from '@/js/components/member/common/Atoms/ErrorMessage'
import TableTh from '@/js/components/member/common/Molecules/TableTh'
import TableTr from '@/js/components/member/common/Molecules/TableTr'
import InputRadio from '@/js/components/member/common/Molecules/InputRadio'
import MaskImage from '@/js/components/common/MaskImage'
import {Loading} from 'element-ui'
export default {
  data() {
    return {
      detailId: '',
      upload_type: '',
      contract: {
        images: {
          indetifications: [],
          parental_consent: [],
          contract_documents: []
        }
      },
      identifications_error: false,
      contract_documents_error: false,
      parental_consent_error: false,
      identifications: [],
      contract_documents: [],
      parental_consent: [],

      note: Note, // 各項目の注意事項
      formUploadFieldes: {}, // 口座系のみのフィールド
      validations: ValidationRules, // バリデーションルール
      form: {
        bank_account_holder: '', // 口座名義人
        bank_account_holder_name: '', // 名義人入力
        bank_account_registration: '', // 口座登録
        bank_account_registration_date: '', // 口座登録日
        is_beri: false, // 本人確認電話
        beri_timing: '審査後すぐ', // 確認日時
        beri_at: null // 指定日時
      },
      isSendPhotoBtnPushed: false,
      isHolidayBeriAt: false,
      bank_account_registration_a: '',
      uploadedImagesDialog: {
        image: {},
        type: '',
        isCanvas: false,
        maskImageUrl: '',
        imageWidth: 0,
        imageHeight: 0,
      }
    }
  },
  components: {
    ErrorMessage,
    RequiredText,
    SegmentName,
    TableTh,
    TableTr,
    InputRadio,
    MaskImage
  },
  computed: {
    beriTime: {
      get() {
        if (!this.form.beri_at) {
          return '09:00'
        }

        return moment(this.form.beri_at).format('HH:mm')
      },
      set(value) {
        const time = value ?? '09:00'
        const beriAt = this.form.beri_at ? moment(this.form.beri_at) : moment()
        this.form.beri_at = beriAt.format(`YYYY-MM-DD ${time}:00`)
      }
    },
    beriTimeOptions() {
      return this.isHolidayBeriAt
        ? this.formUploadFieldes.beriAt.beriAtHolidays
        : this.formUploadFieldes.beriAt.beriAtBusinessDays
    },
    /**
     * 本人確認電話欄の確認日時項目に表示する一覧を生成
     */
    beriTimingOptionList() {
      return this.form.beri_timing === '完了済' ? 
        this.formUploadFieldes.beriTiming.choices
      :
        this.formUploadFieldes.beriTiming.choices.filter(x => x.value !== '完了済')
    }
  },
  mounted() {
    this.detailId = this.$route.params.id
    this.initialize()
  },
  beforeDestroy() {
    // バリデーションを削除
    validate(this.validations, false, this.contract.has_payment)
  },
  methods: {
    back() {
      this.$confirm('変更を保存しますか？', '変更確認', {
        confirmButtonText: 'はい',
        cancelButtonText: '詳細画面へ',
        type: 'info'
      })
        .then(() => {
          this.sendPhoto()
        })
        .catch(() => {
          this.transitionSame('list-detail')
        })
    },
    initialize() {
      axios.get('/api/store/contract/' + this.detailId).then((res) => {
        this.contract = res.data

        // アップロード済画像データを整える
        for (let [key, images] of Object.entries(res.data.images)) {
          images = Object.values(images) // 配列かObjectで来るので配列に統一
          images.forEach((img) => {
            this[key].push({
              url: img.url,
              id: img.id,
              can_delete: false,
              delete: false,
              see: false
            })
          })
        }

        this.form.bank_account_holder = this.contract.bank_account_holder ?? ''
        this.form.bank_account_holder_name = this.contract.bank_account_holder_name ?? ''
        this.form.bank_account_registration = this.contract.bank_account_registration ?? ''
        this.form.bank_account_registration_date = this.contract.bank_account_registration_date ?? ''
        this.form.is_beri = this.contract.is_beri ? true : false
        this.form.beri_timing = this.contract.beri_timing
        this.form.beri_at = this.contract.beri_at
        this.bank_account_registration_a = (this.form.bank_account_registration === 'A済' || this.form.bank_account_registration === 'A予定') ? 'A':''
        this.formUploadFieldes = FormUploadFieldes(
          this.contract.has_payment,
          this.form,
          this.contract.type.toLowerCase()
        )

        this.setBeriAtTimeOption(this.form.beri_at)

        this.$nextTick(() => {
          // バリデーションを定義
          validate(this.validations, true, this.contract.has_payment)
        })
        // 画像を回転させたときにページリロードが必要なため、ここでメッセージを取得して表示
        if(sessionStorage.updateImageMessage) {
          this.$message(sessionStorage.updateImageMessage)
          sessionStorage.removeItem('updateImageMessage')
        }
      })
    },
    activeUploadedImagesDialog(image, type) {
      // ダイアログ初期化
      Object.assign(this.$data.uploadedImagesDialog, this.$options.data().uploadedImagesDialog)
      this.uploadedImagesDialog.image = image
      this.uploadedImagesDialog.type = type
    },
    /**
     * 画像の回転処理
     * @param {number} imageId imagesテーブルのid
     */
     async rotateImage(imageId) {
      const loadingItem = Loading.service({})
      const res = await axios
        .put(`/rotate/${imageId}`)
        .catch((err) => {
          if (err.response.status === 404) {
            this.$message.error('送信に失敗しました。画像が存在しません。')
          } else {
            this.$message.error('サーバーエラーにより送信に失敗しました。')
          }
        })
        if(res.status === 200) {
          sessionStorage.setItem('updateImageMessage', `口座・写真情報　更新完了`)
          // 更新を反映
          window.location.reload()
        }
        loadingItem.close()
    },
    /**
     * 画像の更新処理
     * @param {string} imageData base64形式の画像データ
     */
     // async updateImage(imageData) {
     //  const loadingItem = Loading.service({})
     //  const res = await axios
     //    .put(`/upload/${this.uploadedImagesDialog.image.id}`, {image: imageData})
     //    .catch((err) => {
     //      if (err.response.status === 404) {
     //        this.$message.error('送信に失敗しました。画像データに不備があります。')
     //      } else {
     //        this.$message.error('サーバーエラーにより送信に失敗しました。')
     //      }
     //      loadingItem.close()
     //    })
     //  if(res.status === 200) {
     //    sessionStorage.setItem('updateImageMessage', `口座・写真情報　更新完了`)
     //    // 更新を反映
     //    window.location.reload()
     //  }
     //  loadingItem.close()
     //},
    // changeEditMode() {
    //   this.uploadedImagesDialog.imageWidth = this.$refs.targetImage.width
    //   this.uploadedImagesDialog.imageHeight = this.$refs.targetImage.height
    //   if(this.uploadedImagesDialog.maskImageUrl !== this.uploadedImagesDialog.image.url) this.uploadedImagesDialog.maskImageUrl = this.uploadedImagesDialog.image.url
    //   this.uploadedImagesDialog.see = !this.uploadedImagesDialog.see
    //   this.uploadedImagesDialog.isCanvas = !this.uploadedImagesDialog.isCanvas
    // },
    sendPhoto() {
      this.isSendPhotoBtnPushed = true
      const loadingItem = Loading.service({})
      for (let key in this.validations) {
        this.validations[key].map(async (validation) => {
          await this.ignitionEvent(validation.event, key)
        })
      }
      this.$nextTick(() => {
        let errors = document.querySelectorAll('.error_message')
        let error_class = ''
        for (var i = 0; i < errors.length; i++) {
          if (errors[i].innerHTML) {
            error_class = errors[i].className
            break
          }
        }
        if (error_class) {
          helperSmoothScroll(error_class, true)
          this.$message.error('入力に不備があります。入力内容をご確認ください。')
        } else {
          axios
            .post('/api/store/contract/put-photo/' + this.detailId, {
              identifications: this.identifications.map((img) => {
                return img.id
              }),
              contract_documents: this.contract_documents.map((img) => {
                return img.id
              }),
              parental_consent: this.parental_consent.map((img) => {
                return img.id
              }),
              ...this.form
            })
            .then((res) => {
              this.$message(`写真データの送信を行いました。`)
              this.transitionSame('list-detail')
            })
            .catch((err) => {
              if(err.response.status === 422) {
                this.$message.error('入力に不備があります。入力内容をご確認ください。')
              } else {
                this.$message.error('送信に失敗しました。入力内容をご確認ください。')
              }
            })
        }
      })
      this.isSendPhotoBtnPushed = false
      loadingItem.close()
    },
    activeCamera(type) {
      //カメラを起動する処理
      this.upload_type = type
      document.getElementById('upfile').click()
    },
    uploadImage() {
      //画像を保存する処理
      let element = document.getElementById('upfile')
      if (element.files[0]) {
        const uploadType = this.upload_type

        const loading = this.$loading({
          target: '#' + uploadType,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
          text: 'アップロード中',
          customClass: 'uploadImageLoading'
        })

        // エラーを消す
        this.identifications_error = this.contract_documents_error = this.parental_consent_error = false

        setTimeout(() => {
          uploadFile('/upload', element.files[0])
            .then((response) => {
              const data = response.data
              const imageData = {
                url: data.base64.encoded,
                id: data.image.id,
                can_delete: true,
                delete: false,
                see: false
              }
              if (uploadType == 'identifications') {
                this.identifications.push(imageData)
              }
              if (uploadType == 'contract_documents') {
                this.contract_documents.push(imageData)
              }
              if (uploadType == 'parental_consent') {
                this.parental_consent.push(imageData)
              }

              loading.close()
            })
            .catch((error) => {
              if (uploadType == 'identifications') {
                this.identifications_error = true
              }
              if (uploadType == 'contract_documents') {
                this.contract_documents_error = true
              }
              if (uploadType == 'parental_consent') {
                this.parental_consent_error = true
              }
              loading.close()
            })
        }, 20)
      }
    },

    imageDelete(type, id) {
      //画像を削除する処理
      let imageObjects
      if (type == 'identifications') {
        imageObjects = this.identifications
      }
      if (type == 'contract_documents') {
        imageObjects = this.contract_documents
      }
      if (type == 'parental_consent') {
        imageObjects = this.parental_consent
      }
      imageObjects.some(function (v, i) {
        if (v.id == id) imageObjects.splice(i, 1) //id:3の要素を削除
      })
    },
    /**
     * 口座登録に変更があったとき
     */
    onChangeBankAccountRegistration(e) {
      this.ignitionEvent('blur', 'bank_account_registration')
      this.form.bank_account_registration_date = ''
      if (e === 'A済') {
        this.form.bank_account_registration_date = moment().format('YYYY-MM-DD')
      }else if(e === 'Web登録予定' || e === '口座振替依頼書') {
        this.bank_account_registration_a = ''
      }
    },

    onChangeBankAccountRegistrationA(e) {
      this.ignitionEvent('blur', 'bank_account_registration')
      if(e === 'A') {
        if(this.form.bank_account_registration !== 'A済') {
          this.form.bank_account_registration_date = ''
        }
        if(this.form.bank_account_registration !== 'A済' && this.form.bank_account_registration !== 'A予定') {
          this.form.bank_account_registration = ''
        }
      }
    },

    onChangeBeriTiming(e) {
      this.form.beri_at = null
      this.ignitionEvent('blur', 'beri_at')

      if (e === '指定日時選択') {
        this.form.beri_at = moment().format('YYYY-MM-DD 09:00:00')
        this.setBeriAtTimeOption(this.form.beri_at) // ベリ予定時間の選択範囲
      }
    },

    setBeriAtTimeOption(beriAt) {
      const selectedDate = beriAt ? moment(beriAt, 'YYYY-MM-DD HH:mm:ss') : moment()
      const year = selectedDate.year()
      axios
        .get('/api/store/calendar/', {
          params: {year}
        })
        .then((res) => {
          const {data} = res
          if (!data) return
          let isHoliday = selectedDate.get('day') % 6 === 0 //土日
          if (!isHoliday) {
            const holidays = data.calendarDays.concat(data.nationalHolidays)
            isHoliday = holidays.some(
              (item) => moment(item.date).format('YYYY-MM-DD') === selectedDate.format('YYYY-MM-DD')
            )
          }
          this.isHolidayBeriAt = isHoliday
          this.ignitionEvent('blur', 'beri_at')
        })
        .catch(() => {
          this.$alert('休日情報取得に失敗しました', 'サーバーエラー', {
            confirmButtonText: '閉じる'
          })
        })
    },

    onChangeBeriDate(e) {
      // 予定時刻 年月日変更イベント
      if (e) {
        this.form.beri_at = moment(e).format('YYYY-MM-DD 09:00:00')
        this.setBeriAtTimeOption(this.form.beri_at) // ベリ予定時間の選択範囲
      }
    },

    onChangeBeriTime() {
      this.ignitionEvent('blur', 'beri_at')
    }
  },
  watch: {
    form: {
      async handler(newValue) {
        this.formUploadFieldes = FormUploadFieldes(
          this.contract.has_payment,
          newValue,
          this.contract.type.toLowerCase()
        )
        for (let key in this.validations) {
          this.validations[key].map(async (validation) => {
            await this.ignitionEvent(validation.event, key)
          })
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../../sass/_variables.scss';
.head_data {
  text-align: center;
  font-size: 18px;
  border-bottom: 1px solid#eee;
  padding-bottom: 15px;
  margin-bottom: 15px;
}
.camera {
  padding-top: 40px;

  .delete {
    opacity: 0.3;
  }

  &__item {
    width: 28%;
    height: 22vw;
    margin-bottom: 40px;
    border: 1px solid #d3d3d3;
    border-radius: 10px;
    padding: 5px;
    &:nth-child(3n + 1) {
      margin-left: 4%;
    }
    &:nth-child(3n - 1) {
      margin-left: 4%;
      margin-right: 4%;
    }
    &--inner {
      border: 1px solid #d3d3d3;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      border-radius: 5px;
      & a {
        text-align: center;
        display: inline-block;
      }
      & img {
        max-width: 90%;
        max-height: 21vw; // 規定の高さを入れる（可変）
        height: auto;
        vertical-align: bottom;
      }
    }
    &--add {
      border: 1px solid $--color-primary;
      & .camera__item--inner {
        background-color: #f8f8f8;
      }
    }
  }
  &__icon {
    font-size: 6vw;
  }
  &__txt {
    font-size: 2.5vw;
    margin: 0;
  }
}
.bank-account__reg_list {
  list-style:none;
  padding-inline-start:0;
  ul {
    list-style:none;
    padding-inline-start:23px;
    li {
      div {
        margin-left: 12px;
      }
      p {
        &.notice {
          white-space:nowrap;
          margin-left: 12px;
        }
        &.error_message {
          margin-left: 12px;
        }
      }
    }
  }

  & > li {
    margin-bottom:18px;

    .bank-account__reg_list__a_list {
      li {
        margin-bottom:6px;
      }
    }
    p {
      &.notice {
        white-space:nowrap;
        margin-left: 24px;
      }
      &.error_message {
        margin-left: 24px;
      }
    }
  }
}


.modal {
  &-wrap {
    width: 100%;
    height: 80vh;
    position: relative;
    & img {
      max-width: 100%;
      max-height: 80vh;
      height: auto;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  &__img {
    position: relative;
    & i {
      position: absolute;
      bottom: 5px;
      right: 5px;
      font-size: 3vw;
      cursor: pointer;
    }
  }
}
.mb-2 {
  margin-bottom: 16px;
}
</style>
